import React, { useState } from 'react';
import { KeyRound, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();

    if (!email.trim()) {
      setError('Podaj adres email.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Nie udało się wysłać linku resetującego.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card auth-card--wide auth-card--compact">
        <div className="login-logo">
          <Sparkles size={22} strokeWidth={1.8} />
        </div>
        <p className="login-kicker">Odzyskiwanie dostępu</p>
        <h1 className="login-title auth-title-small">Reset hasła</h1>
        <p className="login-subtitle">Podaj adres email przypisany do konta. Wyślemy link do ustawienia nowego hasła.</p>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">Jeśli konto istnieje, link do resetu został wysłany.</div>}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
                setError('');
              }}
              placeholder="twoj@email.pl"
              autoComplete="email"
              required
            />
          </div>
          <button type="submit" className="btn-primary" disabled={loading}>
            <KeyRound size={16} strokeWidth={1.9} />
            {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
          </button>
        </form>

        <p className="auth-switch-copy">
          Pamiętasz hasło? <Link to="/login" className="auth-switch-link">Wróć do logowania</Link>
        </p>
      </div>
    </div>
  );
}